module.exports = __webpack_public_path__ + "img/instagram.e38bcdc.svg";